"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatusIndicator = exports.STATUS_SEMANTIC = void 0;
var React = _interopRequireWildcard(require("react"));
var COLORS = _interopRequireWildcard(require("../../styles/variables/_color"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _qa = require("../../utils/qa");
var _StatusIndicatorModule = _interopRequireDefault(require("./StatusIndicator.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const STATUS_SEMANTIC = exports.STATUS_SEMANTIC = Object.freeze({
  primary: 'primary',
  information: 'information',
  success: 'success',
  warning: 'warning',
  danger: 'danger',
  neutral: 'neutral',
  secondary: 'secondary'
});
const StatusIndicator = exports.StatusIndicator = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    classNames,
    status = 'information',
    withBorder,
    borderColorToken = 'colorBackgroundTertiary',
    disabled,
    testId,
    ...props
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    ...props,
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'indicator'
    }),
    className: (0, _classify.default)(_StatusIndicatorModule.default.statusWrapper, _StatusIndicatorModule.default[status], {
      [_StatusIndicatorModule.default.withBorder]: withBorder,
      [_StatusIndicatorModule.default.disabled]: disabled
    }, classNames?.wrapper),
    ref: ref,
    style: {
      '--border-color': COLORS[borderColorToken] || COLORS['colorBackgroundTertiary']
    }
  });
});